import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { DatePickerField } from "./fields/DatePickerField";
import { TimePickerField } from "./fields/TimePickerFIeld";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
    },
    date: {
        flex: '2 0 0',
        minWidth: 0,
        marginRight: theme.spacing(0.5),
    },
    time: {
        flex: '1 0 0',
        minWidth: 0,
        marginLeft: theme.spacing(0.5),
    },
}); }, { name: 'SnDateTimePicker' });
/**
 * 日付・時刻選択コンポーネント。
 */
export var DateTimePicker = function (props) {
    var className = props.className, style = props.style, value = props.value, minDate = props.minDate, maxDate = props.maxDate, _a = props.disableFuture, disableFuture = _a === void 0 ? false : _a, _b = props.disablePast, disablePast = _b === void 0 ? false : _b, clearable = props.clearable, onChange = props.onChange;
    var _c = useState(null), localValue = _c[0], setLocalValue = _c[1];
    var currentValue = value !== undefined ? value : localValue;
    var handleChangeDate = useCallback(function (date) {
        var _a;
        // 空状態からのchangeであれば時刻を00:00にセットする。
        var nextValue = currentValue == null ? (_a = date === null || date === void 0 ? void 0 : date.startOf('day')) !== null && _a !== void 0 ? _a : null : date;
        setLocalValue(nextValue);
        if (onChange != null)
            onChange(nextValue);
    }, [onChange, currentValue]);
    var handleChangeTime = useCallback(function (time) {
        var _a;
        // 時刻のクリアでは時刻のみを00:00にクリアする。
        var nextValue = time == null ? (_a = currentValue === null || currentValue === void 0 ? void 0 : currentValue.startOf('day')) !== null && _a !== void 0 ? _a : null : time;
        setLocalValue(nextValue);
        if (onChange != null)
            onChange(nextValue);
    }, [onChange, currentValue]);
    var classes = useStyles(props);
    return (React.createElement("div", { className: classNames(classes.root, className), style: style },
        React.createElement(DatePickerField, { className: classes.date, value: currentValue, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, clearable: clearable, onChange: handleChangeDate }),
        React.createElement(TimePickerField, { className: classes.time, value: currentValue, onChange: handleChangeTime })));
};
